import {Injectable, Injector, OnDestroy} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpService} from 'projects/core/src/public-api';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { EngineeringColumn } from './engineering/engineering-column';
import {TrelloCard} from '../../trello-misc/data/trello-card';
import {EngineeringData} from './engineering/engineering-data';
import {ActionEventEmitter} from '../../../../../../core/src/lib/core/data/action-event-emitter';
import {CdkDragMove} from '@angular/cdk/drag-drop';

@Injectable({
    providedIn: 'root',
})
@RxJSUnsubscribe
export class ActivityEngineeringService extends HttpService implements OnDestroy, RxJSUnsubscribable {

    constructor(
        protected injector: Injector,
        protected appStateQuery: AppStateQuery,
        protected wsService: WsService
    ) {
        super(injector);
    }

    private command$ = new Subject<{ id: number; action: string, target: string }>();
    commandStream$ = this.command$.asObservable();
    sendCommand(id: number, action: string, target: string) {
        this.command$.next({ id, action, target });
    }

    getColumns(type: string = 'ENGINEERING'): Observable<EngineeringData> {
        return this.getData(`/backlog/${type}-data`, EngineeringData);
    }

    moveActivity(id: number, columnId: number, columnName: string, statusId: number, pos: number): Observable<EngineeringColumn> {
        return this.doHttpPut<EngineeringColumn>(`/backlog/move-activity`, {
            id,
            columnId,
            columnName,
            statusId,
            pos
        })
    }

    ngOnDestroy() {

    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}